/**
 * Textos por módulo y recurso (locales/<idioma>/<recurso>.json), con las claves `<recurso>.<texto>`.
 * Cada recurso tiene su archivo para que dos cambios no choquen en el mismo JSON.
 */
import es_common from './locales/es/common.json';
import es_users from './locales/es/users.json';
import es_offices from './locales/es/offices.json';
import es_salesReps from './locales/es/salesReps.json';
import es_clients from './locales/es/clients.json';
import es_routes from './locales/es/routes.json';
import es_loanTypes from './locales/es/loanTypes.json';
import es_expenseTypes from './locales/es/expenseTypes.json';
import es_banks from './locales/es/banks.json';
import es_permissions from './locales/es/permissions.json';
import es_loans from './locales/es/loans.json';
import es_loanActions from './locales/es/loanActions.json';
import es_payments from './locales/es/payments.json';
import es_expenses from './locales/es/expenses.json';
import es_cashBoxes from './locales/es/cashBoxes.json';
import es_routeDevices from './locales/es/routeDevices.json';
import es_paymentCorrections from './locales/es/paymentCorrections.json';
import es_routeSettlement from './locales/es/routeSettlement.json';
import es_visitOrders from './locales/es/visitOrders.json';
import es_routeTracking from './locales/es/routeTracking.json';
import es_visitOrderEditor from './locales/es/visitOrderEditor.json';
import es_loanImports from './locales/es/loanImports.json';
import es_clientImport from './locales/es/clientImport.json';
import es_syncAudit from './locales/es/syncAudit.json';
import es_appNotices from './locales/es/appNotices.json';
import es_dataExport from './locales/es/dataExport.json';
import es_loanTransfers from './locales/es/loanTransfers.json';
import es_dataDeletion from './locales/es/dataDeletion.json';
import es_paymentReports from './locales/es/paymentReports.json';
import es_cashReports from './locales/es/cashReports.json';
import es_loanReports from './locales/es/loanReports.json';
import es_clientReports from './locales/es/clientReports.json';
import es_summaryReports from './locales/es/summaryReports.json';
import es_auditReports from './locales/es/auditReports.json';
import es_products from './locales/es/products.json';
import es_inventory from './locales/es/inventory.json';
import es_writeOffs from './locales/es/writeOffs.json';
import es_devices from './locales/es/devices.json';
import es_correctionApprovals from './locales/es/correctionApprovals.json';
import es_alerts from './locales/es/alerts.json';
import es_salesRepRisk from './locales/es/salesRepRisk.json';
import es_attachments from './locales/es/attachments.json';
import es_notifications from './locales/es/notifications.json';
import es_storageCleanup from './locales/es/storageCleanup.json';
import es_rating from './locales/es/rating.json';
import ptBR_common from './locales/pt-BR/common.json';
import ptBR_users from './locales/pt-BR/users.json';
import ptBR_offices from './locales/pt-BR/offices.json';
import ptBR_salesReps from './locales/pt-BR/salesReps.json';
import ptBR_clients from './locales/pt-BR/clients.json';
import ptBR_routes from './locales/pt-BR/routes.json';
import ptBR_loanTypes from './locales/pt-BR/loanTypes.json';
import ptBR_expenseTypes from './locales/pt-BR/expenseTypes.json';
import ptBR_banks from './locales/pt-BR/banks.json';
import ptBR_permissions from './locales/pt-BR/permissions.json';
import ptBR_loans from './locales/pt-BR/loans.json';
import ptBR_loanActions from './locales/pt-BR/loanActions.json';
import ptBR_payments from './locales/pt-BR/payments.json';
import ptBR_expenses from './locales/pt-BR/expenses.json';
import ptBR_cashBoxes from './locales/pt-BR/cashBoxes.json';
import ptBR_routeDevices from './locales/pt-BR/routeDevices.json';
import ptBR_paymentCorrections from './locales/pt-BR/paymentCorrections.json';
import ptBR_routeSettlement from './locales/pt-BR/routeSettlement.json';
import ptBR_visitOrders from './locales/pt-BR/visitOrders.json';
import ptBR_routeTracking from './locales/pt-BR/routeTracking.json';
import ptBR_visitOrderEditor from './locales/pt-BR/visitOrderEditor.json';
import ptBR_loanImports from './locales/pt-BR/loanImports.json';
import ptBR_clientImport from './locales/pt-BR/clientImport.json';
import ptBR_syncAudit from './locales/pt-BR/syncAudit.json';
import ptBR_appNotices from './locales/pt-BR/appNotices.json';
import ptBR_dataExport from './locales/pt-BR/dataExport.json';
import ptBR_loanTransfers from './locales/pt-BR/loanTransfers.json';
import ptBR_dataDeletion from './locales/pt-BR/dataDeletion.json';
import ptBR_paymentReports from './locales/pt-BR/paymentReports.json';
import ptBR_cashReports from './locales/pt-BR/cashReports.json';
import ptBR_loanReports from './locales/pt-BR/loanReports.json';
import ptBR_clientReports from './locales/pt-BR/clientReports.json';
import ptBR_summaryReports from './locales/pt-BR/summaryReports.json';
import ptBR_auditReports from './locales/pt-BR/auditReports.json';
import ptBR_products from './locales/pt-BR/products.json';
import ptBR_inventory from './locales/pt-BR/inventory.json';
import ptBR_writeOffs from './locales/pt-BR/writeOffs.json';
import ptBR_devices from './locales/pt-BR/devices.json';
import ptBR_correctionApprovals from './locales/pt-BR/correctionApprovals.json';
import ptBR_alerts from './locales/pt-BR/alerts.json';
import ptBR_salesRepRisk from './locales/pt-BR/salesRepRisk.json';
import ptBR_attachments from './locales/pt-BR/attachments.json';
import ptBR_notifications from './locales/pt-BR/notifications.json';
import ptBR_storageCleanup from './locales/pt-BR/storageCleanup.json';
import ptBR_rating from './locales/pt-BR/rating.json';
import en_common from './locales/en/common.json';
import en_users from './locales/en/users.json';
import en_offices from './locales/en/offices.json';
import en_salesReps from './locales/en/salesReps.json';
import en_clients from './locales/en/clients.json';
import en_routes from './locales/en/routes.json';
import en_loanTypes from './locales/en/loanTypes.json';
import en_expenseTypes from './locales/en/expenseTypes.json';
import en_banks from './locales/en/banks.json';
import en_permissions from './locales/en/permissions.json';
import en_loans from './locales/en/loans.json';
import en_loanActions from './locales/en/loanActions.json';
import en_payments from './locales/en/payments.json';
import en_expenses from './locales/en/expenses.json';
import en_cashBoxes from './locales/en/cashBoxes.json';
import en_routeDevices from './locales/en/routeDevices.json';
import en_paymentCorrections from './locales/en/paymentCorrections.json';
import en_routeSettlement from './locales/en/routeSettlement.json';
import en_visitOrders from './locales/en/visitOrders.json';
import en_routeTracking from './locales/en/routeTracking.json';
import en_visitOrderEditor from './locales/en/visitOrderEditor.json';
import en_loanImports from './locales/en/loanImports.json';
import en_clientImport from './locales/en/clientImport.json';
import en_syncAudit from './locales/en/syncAudit.json';
import en_appNotices from './locales/en/appNotices.json';
import en_dataExport from './locales/en/dataExport.json';
import en_loanTransfers from './locales/en/loanTransfers.json';
import en_dataDeletion from './locales/en/dataDeletion.json';
import en_paymentReports from './locales/en/paymentReports.json';
import en_cashReports from './locales/en/cashReports.json';
import en_loanReports from './locales/en/loanReports.json';
import en_clientReports from './locales/en/clientReports.json';
import en_summaryReports from './locales/en/summaryReports.json';
import en_auditReports from './locales/en/auditReports.json';
import en_products from './locales/en/products.json';
import en_inventory from './locales/en/inventory.json';
import en_writeOffs from './locales/en/writeOffs.json';
import en_devices from './locales/en/devices.json';
import en_correctionApprovals from './locales/en/correctionApprovals.json';
import en_alerts from './locales/en/alerts.json';
import en_salesRepRisk from './locales/en/salesRepRisk.json';
import en_attachments from './locales/en/attachments.json';
import en_notifications from './locales/en/notifications.json';
import en_storageCleanup from './locales/en/storageCleanup.json';
import en_rating from './locales/en/rating.json';
export const esParts = { ...es_common, ...es_users, ...es_offices, ...es_salesReps, ...es_clients, ...es_routes, ...es_loanTypes, ...es_expenseTypes, ...es_banks, ...es_permissions, ...es_loans, ...es_loanActions, ...es_payments, ...es_expenses, ...es_cashBoxes, ...es_routeDevices, ...es_paymentCorrections, ...es_routeSettlement, ...es_visitOrders, ...es_routeTracking, ...es_visitOrderEditor, ...es_loanImports, ...es_clientImport, ...es_syncAudit, ...es_appNotices, ...es_dataExport, ...es_loanTransfers, ...es_dataDeletion, ...es_paymentReports, ...es_cashReports, ...es_loanReports, ...es_clientReports, ...es_summaryReports, ...es_auditReports, ...es_products, ...es_inventory, ...es_writeOffs, ...es_devices, ...es_correctionApprovals, ...es_alerts, ...es_rating, ...es_salesRepRisk, ...es_attachments, ...es_notifications, ...es_storageCleanup };
export const ptBRParts = { ...ptBR_common, ...ptBR_users, ...ptBR_offices, ...ptBR_salesReps, ...ptBR_clients, ...ptBR_routes, ...ptBR_loanTypes, ...ptBR_expenseTypes, ...ptBR_banks, ...ptBR_permissions, ...ptBR_loans, ...ptBR_loanActions, ...ptBR_payments, ...ptBR_expenses, ...ptBR_cashBoxes, ...ptBR_routeDevices, ...ptBR_paymentCorrections, ...ptBR_routeSettlement, ...ptBR_visitOrders, ...ptBR_routeTracking, ...ptBR_visitOrderEditor, ...ptBR_loanImports, ...ptBR_clientImport, ...ptBR_syncAudit, ...ptBR_appNotices, ...ptBR_dataExport, ...ptBR_loanTransfers, ...ptBR_dataDeletion, ...ptBR_paymentReports, ...ptBR_cashReports, ...ptBR_loanReports, ...ptBR_clientReports, ...ptBR_summaryReports, ...ptBR_auditReports, ...ptBR_products, ...ptBR_inventory, ...ptBR_writeOffs, ...ptBR_devices, ...ptBR_correctionApprovals, ...ptBR_alerts, ...ptBR_rating, ...ptBR_salesRepRisk, ...ptBR_attachments, ...ptBR_notifications, ...ptBR_storageCleanup };
export const enParts = { ...en_common, ...en_users, ...en_offices, ...en_salesReps, ...en_clients, ...en_routes, ...en_loanTypes, ...en_expenseTypes, ...en_banks, ...en_permissions, ...en_loans, ...en_loanActions, ...en_payments, ...en_expenses, ...en_cashBoxes, ...en_routeDevices, ...en_paymentCorrections, ...en_routeSettlement, ...en_visitOrders, ...en_routeTracking, ...en_visitOrderEditor, ...en_loanImports, ...en_clientImport, ...en_syncAudit, ...en_appNotices, ...en_dataExport, ...en_loanTransfers, ...en_dataDeletion, ...en_paymentReports, ...en_cashReports, ...en_loanReports, ...en_clientReports, ...en_summaryReports, ...en_auditReports, ...en_products, ...en_inventory, ...en_writeOffs, ...en_devices, ...en_correctionApprovals, ...en_alerts, ...en_rating, ...en_salesRepRisk, ...en_attachments, ...en_notifications, ...en_storageCleanup };
